import React from 'react';
import Button from '../core/Button';
import Modal from './Modal';

export interface Props {
  open: boolean;
  title?: string;
  text?: string;
  onClose?: () => void;
  onYes?: () => void;
}

export default function YesNoPrompt(props: Props) {
  return (
    <Modal
      title={props.title || 'TODO:'}
      open={props.open}
      onClose={props.onClose}
    >
      <p>{props.text}</p>
      <div
        style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 15 }}
      >
        <Button style={{ minWidth: 80 }} label="NO" onClick={props.onClose} />
        <Button
          style={{ minWidth: 80, marginLeft: 10 }}
          label="SI"
          onClick={props.onYes}
        />
      </div>
    </Modal>
  );
}
